/* eslint-disable no-template-curly-in-string */
import moment from "moment";
import "moment/locale/pt-br";
import { setLocale as setYupLocale } from "yup";
import i18n from "i18next";

const yupLocales = {
  "pt-BR": {
    mixed: {
      default: "Valor inválido",
      required: "Campo obrigatório",
      oneOf: "${path} deve ser um dos seguintes valores: ${values}",
      notOneOf: "${path} não pode ser um dos seguintes valores: ${values}"
    },
    string: {
      length: "${path} deve ter exatamente ${length} caracteres",
      min: "${path} deve ter pelo menos ${min} caracteres",
      max: "${path} deve ter no máximo ${max} caracteres",
      email: "${path} tem o formato de e-mail inválido",
      url: "${path} deve ter um formato de URL válida",
      trim: "${path} não deve conter espaços no início ou no fim.",
      lowercase: "${path} deve estar em minúsculo",
      uppercase: "${path} deve estar em maiúsculo"
    },
    number: {
      min: "${path} deve ser no mínimo ${min}",
      max: "${path} deve ser no máximo ${max}",
      lessThan: "${path} deve ser menor que ${less}",
      moreThan: "${path} deve ser maior que ${more}",
      notEqual: "${path} não pode ser igual a ${notEqual}",
      positive: "${path} deve ser um número positivo",
      negative: "${path} deve ser um número negativo",
      integer: "${path} deve ser um número inteiro"
    },
    date: {
      min: "${path} deve ser maior que a data ${min}",
      max: "${path} deve ser menor que a data ${max}"
    },
    array: {
      min: "${path} deve ter no mínimo ${min} itens",
      max: "${path} deve ter no máximo ${max} itens"
    }
  },
  en: {
    mixed: {
      default: "Invalid value",
      required: "Required field",
      oneOf: "${path} must be one of the following values: ${values}",
      notOneOf: "${path} must not be one of the following values: ${values}"
    },
    string: {
      length: "${path} must be exactly ${length} characters",
      min: "${path} must be at least ${min} characters",
      max: "${path} must be at most ${max} characters",
      email: "${path} must be a valid email",
      url: "${path} must be a valid URL",
      trim: "${path} must not contain leading or trailing spaces",
      lowercase: "${path} must be lowercase",
      uppercase: "${path} must be uppercase"
    },
    number: {
      min: "${path} must be at least ${min}",
      max: "${path} must be at most ${max}",
      lessThan: "${path} must be less than ${less}",
      moreThan: "${path} must be greater than ${more}",
      notEqual: "${path} must not equal ${notEqual}",
      positive: "${path} must be a positive number",
      negative: "${path} must be a negative number",
      integer: "${path} must be an integer"
    },
    date: {
      min: "${path} must be later than ${min}",
      max: "${path} must be earlier than ${max}"
    },
    array: {
      min: "${path} must have at least ${min} items",
      max: "${path} must have at most ${max} items"
    }
  }
};

/* eslint-disable no-template-curly-in-string */

export const getMuiLocaleCode = lng =>
  lng && lng.toLowerCase().startsWith("en") ? "enUS" : "ptBR";

export const syncDocumentLang = lng => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng || "pt-BR";
  }
};

export const syncMomentLocale = lng => {
  moment.locale(lng && lng.toLowerCase().startsWith("en") ? "en" : "pt-br");
};

export const syncYupLocale = lng => {
  const key = lng && lng.toLowerCase().startsWith("en") ? "en" : "pt-BR";
  setYupLocale(yupLocales[key]);
};

export const syncAllLocales = lng => {
  const language = lng || i18n.language || "pt-BR";
  syncDocumentLang(language);
  syncMomentLocale(language);
  syncYupLocale(language);
};

export const bindI18nLocaleSync = () => {
  syncAllLocales(i18n.language);
  i18n.on("languageChanged", syncAllLocales);
};

export default bindI18nLocaleSync;
